import { Client, gql, fetchExchange } from "@urql/core";

function ExceptionError({ name, message }) {
  return { name, message };
}

function appendQueryParams(url) {
  const urlObj = new URL(url);

  urlObj.searchParams.set("companycode", window.appSettings.companyCode);

  if (window.appSettings.companyCodeVersion) {
    urlObj.searchParams.set("v", window.appSettings.companyCodeVersion);
  }
  if (window.appSettings.language && window.appSettings.language.length) {
    urlObj.searchParams.set("lang", window.appSettings.language);
  }

  if (window.appSettings.isPreview) {
    urlObj.searchParams.set("isPreview", window.appSettings.isPreview);
  }

  return urlObj.toString();
}

export const client = new Client({
  url: appendQueryParams(window.appSettings.sDataApiUrl),
  exchanges: [fetchExchange],
  fetchOptions: () => ({
    headers: { "Content-Type": "application/json" },
  }),
});

export const clientRT = new Client({
  url: appendQueryParams(window.appSettings.sDataApiUrl),
  exchanges: [fetchExchange],
  fetchOptions: () => ({
    headers: { "Content-Type": "application/json", "x-db-rtdata": true },
  }),
});

export const createClientWithDynamicUrl = (url = window.appSettings.sDataApiUrl) => {
  return new Client({
    url: appendQueryParams(url),
    exchanges: [fetchExchange],
    fetchOptions: () => ({
      headers: {
        "Content-Type": "application/json",
      },
    }),
  });
};

// Hàm xử lý API chung
const apiExport = {
  request: async ({ method, path, query, variables = {} }) => {

    const activeClient = createClientWithDynamicUrl(path);
    const parsedQuery = typeof query === "string" ? gql`${query}` : query;

    let result;
    switch (method) {
      case "POST":
        result = await activeClient.executeQuery({ query: parsedQuery, variables }).toPromise();
        break;
      case "PUT":
        result = await activeClient.executeMutation({ query: parsedQuery, variables }).toPromise();
        break;
      default:
        throw new ExceptionError({ name: "Invalid Method", message: `Method ${method} is not supported` });
    }

    if (!result) {
      throw new ExceptionError({ name: "GraphQL Error", message: "No response from server" });
    }

    const { error, data } = result;
    const results = {
      data: data,
    }
    if (error) {
      switch (error.networkError?.statusCode) {
        case 200:
          return results;
        case 504:
          throw new ExceptionError({ name: "Error", message: "Gateway Timeout (504)" });
        default:
          throw new ExceptionError({ name: "GraphQL Error", message: error.message });
      }
    }

    return results;
  },

  POST: async (path, { query, variables = {} }) => {
    return apiExport.request({ method: "POST", path, query, variables });
  },

  PUT: async (path, { query, variables = {} }) => {
    return apiExport.request({ method: "PUT", path, query, variables });
  },
};

export default apiExport;
